import { FormattedMessage } from '@flipster/i18n';
import { css } from '@flipster/styled-system/css';
import { stack } from '@flipster/styled-system/patterns';

import { Accordion } from '../../../../shared/faq-accordion';

export const Faq = () => {
  return (
    <section
      className={stack({
        gap: { tabletDown: 20, tablet: 24 },
        pt: 64,
        bg: 'background.default.level-0',
      })}
    >
      <h2
        className={css({
          textStyle: 'Title/L',
          color: 'content.default.level-5',
        })}
      >
        <FormattedMessage id='Common.r251107.Faq' />
      </h2>
      <Accordion.Root headingLevel={3}>
        {[
          {
            title: <FormattedMessage id='Earn.r251204.What_is_dynamic_earn_faq_title' />,
            description: <FormattedMessage id='Earn.r251204.What_is_dynamic_earn_faq_answer' />,
          },
          {
            title: <FormattedMessage id='Earn.r251204.What_are_risks_faq_title' />,
            description: <FormattedMessage id='Earn.r251204.What_are_risks_faq_answer' />,
          },
          {
            title: <FormattedMessage id='Earn.r251204.Where_rewards_come_from_faq_title' />,
            description: (
              <ul className={css({ list: 'disc', textStyle: 'Text/M/Regular', color: 'content.default.level-3' })}>
                <li>
                  <FormattedMessage id='Earn.r260304.Where_rewards_come_from_faq_answer_1' />
                </li>
                <li>
                  <FormattedMessage id='Earn.r260304.Where_rewards_come_from_faq_answer_2' />
                </li>
                <li>
                  <FormattedMessage id='Earn.r260304.Where_rewards_come_from_faq_answer_3' />
                </li>
              </ul>
            ),
          },
          {
            title: <FormattedMessage id='Earn.r251204.How_rewards_calculated_faq_title' />,
            description: <FormattedMessage id='Earn.r251204.How_rewards_calculated_faq_answer' />,
          },
          {
            title: <FormattedMessage id='Autogen_common.r251126.s_When_will_I_receive_my_rewards' />,
            description: <FormattedMessage id='Earn.r251204.When_receive_rewards_faq_answer' />,
          },
        ].map((faq, index) => (
          <Accordion.Item key={index}>
            <Accordion.Header index={index + 1}>{faq.title}</Accordion.Header>
            <Accordion.Panel css={{ textStyle: 'Text/M/Regular', color: 'content.default.level-2' }}>
              {faq.description}
            </Accordion.Panel>
          </Accordion.Item>
        ))}
      </Accordion.Root>
    </section>
  );
};
